const FUTURE_ACCOUNT_STR = "Include future eligible accounts"

export default FUTURE_ACCOUNT_STR
